import React, {FC, useEffect, useRef, useState} from "react"
import styled from "styled-components"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body, H3} from "@irati/ui/src/Typography"
import Modal from "@irati/ui/src/GenericModal"
import Spinner from "@irati/ui/src/Loading/Spinner"
import {walletTracking} from "@irati-tracking/wallet"

interface Props {
  isModalOpen: boolean
  setIsModalOpen: (isModalOpen: boolean) => void
  url: string
}

const initialCount = 5

const StyledModal = styled(Modal)`
  z-index: 10000;
`

const CashbackInterstitialModal: FC<Props> = ({isModalOpen, url, setIsModalOpen}) => {
  const [count, setCount] = useState(initialCount)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (isModalOpen) {
      setCount(initialCount)
      intervalRef.current = setInterval(() => {
        setCount((prev) => {
          if (prev === 1) {
            window.open(url, "_blank")
            setIsModalOpen(false)
            clearInterval(intervalRef.current!)
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => clearInterval(intervalRef.current!)
    }
  }, [isModalOpen, url])

  const handleCloseModal = () => {
    setIsModalOpen(false)
    if (intervalRef.current) {
      clearInterval(intervalRef.current)
    }
    walletTracking.clickCashbackCTA("dismiss", "cashback_interstitial_modal")
  }

  return (
    <StyledModal small={true} show={isModalOpen} hideActions onHide={handleCloseModal}>
      <Flex direction="column" alignItems="center" gap={1.5}>
        <H3>
          <FormattedMessage id="perks.components.cashbackRedemptionInstructions.modal.title" />
        </H3>
        <Body small>
          <FormattedMessage id="perks.components.cashbackRedemptionInstructions.modal.subtitle" values={{count: count}} />
        </Body>
        <Flex justifyContent="center" marginBottom={2}>
          <Spinner size="lg" />
        </Flex>
      </Flex>
    </StyledModal>
  )
}

export {CashbackInterstitialModal}
